export const CRYPTO_SECRET = 'my-secret-key@12345'
